import { Card, Icon, Layout, Stack, DisplayText, Button, TextField } from "@shopify/polaris"
import { AppExtensionMinor, TickMinor } from "@shopify/polaris-icons"
import { Toast } from "@shopify/app-bridge-react"
import React, { Component } from "react"
import "./style.scss"
import axios from "../../funcs/axios"
import { connect } from "react-redux"
import moment from "moment"
function mapStateToProps(state) {
    return {
        plan: state.plan,
        app_settings: state.app_settings,
    }
}
class Plan extends Component {
    state = {
        faqSelected: 0,
        code: "",
        toast: {
            error: false,
            content: "",
            show: false,
        },
    }

    handlePlan(planName) {
        let data = {
            planName,
        }
        if (planName == "free") {
            this.props.app_settings.wishlist_settings.launch_add.check_add_variant = false
            this.props.app_settings.wishlist_settings.launch_add.showCount = false
            this.props.app_settings.wishlist_settings.launch_add.back_in_stock = false
            axios
                .post(`${window.SHOPIFY_APP_HOST}/admin/save-app-settings`, this.props.app_settings)
                .then((res) => console.log(res))
        }
        axios.post(`${window.SHOPIFY_APP_HOST}/admin/upgrade-plan`, data).then((response) => {
            let data = response.data
            if (data.status == "success") {
                if (data.url) {
                    window.top.location.replace(data.url)
                } else {
                    window.location.reload()
                }
            }
        })
    }

    handleApplyCoupon = (code) => {
        let data = {
            code,
        }
        axios.post(`${window.SHOPIFY_APP_HOST}/admin/apply-coupon`, data).then((res) => {
            let error = false
            if (res.data.status == "error") {
                error = true
            }
            this.setState({
                toast: { show: true, content: res.data.msg, error },
            })
            if (res.data.status == "success") {
                window.location.reload()
            }
        })
    }

    handleOpenFaq(item) {
        this.setState({ faqSelected: item.id })
    }

    render() {
        const { code, toast } = this.state
        console.log(this.props.plan)
        const checkPro =
            this.props.plan.plan == "pro" || this.props.plan.plan == "trial"  ? true : false
        const checkFree = this.props.plan.plan == "free" ? true : false
        const exprirationDate = moment(this.props.plan.expiration_date).format("MMMM Do YYYY")
        return (
            <div className="wl-plan">
                <Card.Section>
                    <div className="wl-page-wrapper">
                        <div className="wl-banner">
                            <Icon source={AppExtensionMinor} />
                            <span className="wl-banner__title">Plan</span>
                        </div>
                        <div className="wl-page-body">
                            <div className="plan-items">
                                <div
                                    className={
                                        this.props.plan.plan == "free"
                                            ? "wl-plan-item selected"
                                            : "wl-plan-item"
                                    }
                                >
                                    <Layout>
                                        <Layout.Section>
                                            <Stack distribution="center">
                                                <Stack.Item>
                                                    <div className="plan-items__title">
                                                        <DisplayText size="large">FREE</DisplayText>
                                                    </div>
                                                </Stack.Item>
                                            </Stack>
                                            <hr />
                                        </Layout.Section>
                                        <Layout.Section>
                                            <div className="price">
                                                <Stack vertical distribution="center">
                                                    <Stack.Item>
                                                        <div className="plan-items__title">
                                                            <DisplayText size="medium">
                                                                free
                                                            </DisplayText>
                                                        </div>
                                                    </Stack.Item>
                                                    <Stack.Item>
                                                        <div className="plan-items__title">
                                                            <DisplayText size="small">
                                                                FREE Forever
                                                            </DisplayText>
                                                        </div>
                                                    </Stack.Item>
                                                </Stack>
                                                <hr />
                                            </div>
                                        </Layout.Section>
                                        <Layout.Section>
                                            <Stack vertical>
                                                <Stack.Item>
                                                    <Stack alignment="center">
                                                        <Icon  color="success" source={TickMinor} />
                                                        <DisplayText size="small">
                                                            Easy, code-free setup
                                                        </DisplayText>
                                                    </Stack>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Stack alignment="center">
                                                        <Icon  color="success" source={TickMinor} />
                                                        <DisplayText size="small">
                                                            Unlimited wishlist functionality
                                                        </DisplayText>
                                                    </Stack>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Stack alignment="center">
                                                        <Icon  color="success" source={TickMinor} />
                                                        <DisplayText size="small">
                                                            Up to 20 wishlist items/ list
                                                        </DisplayText>
                                                    </Stack>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Stack alignment="center">
                                                        <Icon  color="success" source={TickMinor} />
                                                        <DisplayText size="small">
                                                            Share WL via Social Media
                                                        </DisplayText>
                                                    </Stack>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Stack alignment="center">
                                                        <Icon  color="success" source={TickMinor} />
                                                        <DisplayText size="small">
                                                            Free Forever
                                                        </DisplayText>
                                                    </Stack>
                                                </Stack.Item>
                                            </Stack>
                                        </Layout.Section>
                                        <Layout.Section>
                                            <Stack.Item>
                                                <Stack distribution="center">
                                                    <Button
                                                        primary={!checkFree}
                                                        size="large"
                                                        disabled={checkFree}
                                                        onClick={() => this.handlePlan("free")}
                                                    >
                                                        {checkFree ? "Current Plan" : "Downgrade"}
                                                    </Button>
                                                </Stack>
                                            </Stack.Item>
                                        </Layout.Section>
                                    </Layout>
                                </div>
                                <div
                                    className={
                                        this.props.plan.plan == "pro" ||
                                        this.props.plan.plan == "trial"
                                            ? "wl-plan-item selected"
                                            : "wl-plan-item"
                                    }
                                >
                                    <Layout>
                                        <Layout.Section>
                                            <Stack distribution="center">
                                                <Stack.Item sty>
                                                    <div className="plan-items__title">
                                                        <DisplayText size="large">PRO</DisplayText>
                                                        <DisplayText size="small">
                                                            {this.props.plan.plan == "trial"
                                                                ? `(TRIAL: ${this.props.plan.trial_day} days trial)`
                                                                : ""}
                                                        </DisplayText>
                                                    </div>
                                                </Stack.Item>
                                            </Stack>
                                            <hr />
                                        </Layout.Section>
                                        <Layout.Section>
                                            <div className="price">
                                                <Stack vertical distribution="center">
                                                    <Stack.Item>
                                                        <div className="plan-items__title">
                                                            <DisplayText size="medium">
                                                                $12.99/month
                                                            </DisplayText>
                                                        </div>
                                                    </Stack.Item>
                                                    <Stack.Item>
                                                        <div className="plan-items__title">
                                                            <DisplayText size="small">
                                                                {this.props.plan.trial_day} days
                                                                trial
                                                            </DisplayText>
                                                        </div>
                                                    </Stack.Item>
                                                </Stack>
                                                <hr />
                                            </div>
                                        </Layout.Section>
                                        <Layout.Section>
                                            <Stack vertical>
                                                <Stack.Item>
                                                    <Stack alignment="center">
                                                        <Icon  color="success" source={TickMinor} />
                                                        <DisplayText size="small">
                                                            All features of free plan
                                                        </DisplayText>
                                                    </Stack>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Stack alignment="center">
                                                        <Icon  color="success" source={TickMinor} />
                                                        <DisplayText size="small">
                                                            Unlimited wishlist items/list
                                                        </DisplayText>
                                                    </Stack>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Stack alignment="center">
                                                        <Icon  color="success" source={TickMinor} />
                                                        <DisplayText size="small">
                                                            Multiple Lists
                                                        </DisplayText>
                                                    </Stack>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Stack alignment="center">
                                                        <Icon  color="success" source={TickMinor} />
                                                        <DisplayText size="small">
                                                            WL reminder emails
                                                        </DisplayText>
                                                    </Stack>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Stack alignment="center">
                                                        <Icon  color="success" source={TickMinor} />
                                                        <DisplayText size="small">
                                                            Back in stock email triggers
                                                        </DisplayText>
                                                    </Stack>
                                                </Stack.Item>
                                            </Stack>
                                        </Layout.Section>
                                        <Layout.Section>
                                            <Stack.Item>
                                                <Stack distribution="center">
                                                    <Button
                                                        size="large"
                                                        destructive={!checkPro}
                                                        disabled={checkPro}
                                                        onClick={() => this.handlePlan("pro")}
                                                    >
                                                        {checkPro ? "Current Plan" : "Upgrade"}
                                                    </Button>
                                                </Stack>
                                            </Stack.Item>
                                        </Layout.Section>
                                        {this.props.plan.plan == "trial" && (
                                            <div className="expiration-date">
                                                <p>
                                                    Trial expires on: <b>{exprirationDate}</b>
                                                </p>
                                            </div>
                                        )}
                                    </Layout>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card.Section>
                <Card.Section>
                    <div className="wl-page-wrapper">
                        <div className="wl-apply-coupons">
                            <Stack vertical alignment="center">
                                <DisplayText size="medium">COUPON CODE</DisplayText>

                                <DisplayText size="small">
                                    <b>Note:</b> the coupon code applies
                                </DisplayText>
                                <Stack alignment="center" distribution="fill">
                                    <TextField
                                        onChange={(val) => this.setState({ code: val })}
                                        value={code}
                                    ></TextField>
                                    <Button
                                        disabled={!code}
                                        destructive={code}
                                        onClick={() => this.handleApplyCoupon(code)}
                                    >
                                        Apply code
                                    </Button>
                                </Stack>
                            </Stack>
                        </div>
                    </div>
                </Card.Section>
                {toast.show && (
                    <Toast
                        content={toast.content}
                        error={toast.error}
                        onDismiss={() =>
                            this.setState({
                                toast: { show: false, content: "", error: false },
                            })
                        }
                    />
                )}
            </div>
        )
    }
}
export default connect(mapStateToProps, null)(Plan)
